import styled from 'styled-components';
import { HistoryGraphLoading } from '../../styles';

export const UnitsInfoContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 169px);
  gap: 12px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, minmax(0, 169px));
  }
`;

export const HistoryCardLoading = styled(HistoryGraphLoading)`
  .skeleton-span {
    width: 712px;
  }

  @media (max-width: 768px) {
    width: 100%;

    .skeleton-container-span {
      width: 100%;
    }

    .skeleton-span {
      width: 100%;
    }
  }
`;
